"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_bundles__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "09b15017-861e-4dee-b227-9394b15334dd",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa296a07-8fc9-4b7b-be55-39c78cc8a510",
    x1: 62.43,
    y1: 101.78,
    x2: 111.96,
    y2: 151.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "bundles-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "067d6b38-b4ea-4dc0-b58d-20fe532f03a5",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,44.38,32,74,13.76,56.4c-1-1-1-4.43.23-5L70,26.86a4,4,0,0,1,4.17.47Z",
    transform: "translate(0 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,44.38,160,74l18.24-17.6c1-1,1-4.41-.22-5L122,26.86a4,4,0,0,0-4.17.47Z",
    transform: "translate(0 0)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,44.38,32,74,13.76,56.4c-1-1-1-4.43.23-5L70,26.86a4,4,0,0,1,4.17.47Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,44.38,160,74l18.24-17.6c1-1,1-4.41-.22-5L122,26.86a4,4,0,0,0-4.17.47Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,100.5,32,72v65.39A4,4,0,0,0,34.4,141l58.4,25.54a8,8,0,0,0,6.41,0L157.6,141a4,4,0,0,0,2.4-3.66V72L96,100.5Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,100.5v66.76a8,8,0,0,0,3.21-.67L157.6,141a4,4,0,0,0,2.4-3.66V72Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,42.38,32,72,13.76,54.4a2,2,0,0,1,.54-3.25L70,24.86a4,4,0,0,1,4.17.47Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,42.38,160,72l18.24-17.6a2,2,0,0,0-.54-3.25L122,24.86a4,4,0,0,0-4.17.47Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96 100.56 32 72 96 42.37 96 100.56",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96 100.56 160 72 96 42.37 96 100.56",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96 100.56 32 72 96 42.37 96 100.56",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.21,100.12,160,72,96,100.55l17.53,30.31a4,4,0,0,0,5.16,1.62l56.8-26.66A4,4,0,0,0,177.21,100.12Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.79,100.12,32,72l64,28.55L78.47,130.87a4,4,0,0,1-5.16,1.62L16.5,105.83A4,4,0,0,1,14.79,100.12Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,100.55,78.47,130.87a4,4,0,0,1-5.16,1.62L45,119.2l47.07,47.07.73.32a8,8,0,0,0,3.21.67V100.5h0Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#fa296a07-8fc9-4b7b-be55-39c78cc8a510)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.6,139,99.21,164.59a8,8,0,0,1-6.41,0L34.4,139a4,4,0,0,1-2.4-3.66v2A4,4,0,0,0,34.4,141l58.4,25.54a8,8,0,0,0,6.41,0L157.6,141a4,4,0,0,0,2.4-3.66v-2A4,4,0,0,1,157.6,139Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.5,103.83l-56.8,26.66a4,4,0,0,1-5.16-1.62L96.92,100.14l-.92.41,17.53,30.31a4,4,0,0,0,5.16,1.62l56.8-26.66a4,4,0,0,0,2.16-4.6A4,4,0,0,1,175.5,103.83Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.47,128.87a4,4,0,0,1-5.16,1.62L16.5,103.83a4,4,0,0,1-2.16-2.6,4,4,0,0,0,2.16,4.6l56.8,26.66a4,4,0,0,0,5.16-1.62L96,100.55l-.92-.41Z",
    transform: "translate(0 0)",
    opacity: 0.12
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_bundles__dark;
exports.default = _default;